<template>
  <div class="table">
    <div class="table__header">
      <div>
        <span v-if="selectable">
          <input
            type="checkbox"
            v-model="selectAll"
            @click.stop="toggleSelectAll"
          />
        </span>
        {{ selectable ? 'Select All' : 'Prefix' }}
      </div>
      <div>
        <span class="table__protocol">Type of Attack</span>
      </div>
      <div>Hits</div>
    </div>
    <div class="table__body">
      <div class="table__msg" v-if="!data.length">{{ noDataText }}</div>
      <div v-for="d of data" :key="JSON.stringify(d)">
        <div
          class="table__row"
          :class="isExpanding(d.prefix, d.protocol) ? 'show' : ''"
          @click="toggleExpand(d)"
        >
          <div
            class="table__cell"
            v-for="(column, index) of columns"
            :key="column.key"
          >
            <span v-if="selectable && index === 0" class="mr-2">
              <input
                type="checkbox"
                :value="d[column.key]"
                v-model="selectedPrefixes"
                @click.stop="togglePrefix(d[column.key])"
              />
            </span>
            <span class="clickable">{{ d[column.key] | parseProtocol }}</span>
            <span
              v-if="index === 0 && d.sourceIP && d.sourceIP.length"
              class="ml-2 clickable"
            >
              <fa
                :icon="
                  isExpanding(d.prefix, d.protocol) ? 'caret-up' : 'caret-down'
                "
              ></fa>
            </span>
          </div>
        </div>
        <TableExpansion
          v-if="isExpanding(d.prefix, d.protocol)"
          :data="d"
          :key="d.prefix + d.protocol"
          :selectable="selectable"
        />
      </div>
    </div>
  </div>
</template>

<script>
import TableExpansion from './TableExpansion';
import { mapGetters } from 'vuex';

export default {
  props: ['data', 'noDataText', 'selectable', 'fullData', 'expandAll'],
  data() {
    return {
      currentExpanding: new Set(),
      selectAll: false,
      allIPs: [],
      allPrefixes: [],
      selectedPrefixes: []
    };
  },
  watch: {
    selectedIPs(value) {
      this.selectAll = false;
      let allIPIncluded = true;
      if (this.allIPs.length && this.allIPs.length === value.length) {
        this.selectAll = true;
      }
      // check all ips whin a prefix are checked
      this.selectedPrefixes = [];
      this.allPrefixes.forEach(i => {
        if (
          !i.ip.some(j => !value.includes(j)) &&
          !this.selectedPrefixes.includes(i.prefix)
        ) {
          this.selectedPrefixes.push(i.prefix);
        }
      });
    },
    currentExpanding() {
      this.$emit('onExpandChange', this.currentExpanding.size);
    },
    expandAll(val) {
      if (val === null) {
        return;
      }
      this.currentExpanding = new Set();
      if (val && this.fullData) {
        this.fullData.forEach(i => {
          this.showExpand(i);
        });
      }
    },
    fullData: {
      immediate: true,
      handler(value) {
        const ips = new Set();
        const prefixes = [];
        this.currentExpanding = new Set();

        value.forEach(i => {
          if (i.sourceIP) {
            const prefixes = { prefix: i.prefix, ip: [] };
            i.sourceIP.forEach(j => {
              ips.add(j.ip);
              prefixes.ip.push(j.ip);
            });
            this.allPrefixes.push(prefixes);
          }
          // expand all by default
          this.showExpand(i);
        });
        this.allIPs = [...ips];
      }
    }
  },
  computed: {
    ...mapGetters('helpStore', ['selectedIPs']),
    columns() {
      const columns = [
        {
          title: 'Prefix',
          key: 'prefix'
        },
        {
          title: 'Protocols / Dest. port',
          key: 'protocol'
        },
        {
          title: 'Hits',
          key: 'count'
        }
      ];
      return columns;
    }
  },
  filters: {
    parseProtocol(value) {
      if (value === 'ssh') {
        return value.toUpperCase();
      } else if (value === 'ip') {
        return 'Scanning';
      }
      return value;
    }
  },
  methods: {
    toggleExpand(data) {
      if (this.currentExpanding.has(data.prefix + data.protocol)) {
        this.currentExpanding.delete(data.prefix + data.protocol);
        this.currentExpanding = new Set([...this.currentExpanding]);

        return;
      }

      if (data.sourceIP.length) {
        this.currentExpanding.add(data.prefix + data.protocol);
        this.currentExpanding = new Set([...this.currentExpanding]);
      }
    },
    showExpand(data) {
      if (data.sourceIP.length) {
        this.currentExpanding.add(data.prefix + data.protocol);
        this.currentExpanding = new Set([...this.currentExpanding]);
      }
    },
    isExpanding(prefix, protocol) {
      return this.currentExpanding.has(prefix + protocol);
    },
    togglePrefix(prefix) {
      const ips = this.allPrefixes.find(i => i.prefix === prefix).ip;
      // includes means un-check
      if (this.selectedPrefixes.includes(prefix)) {
        const selectedIPs = [...this.selectedIPs].filter(i => !ips.includes(i));
        this.$store.commit('helpStore/setSelectedIPs', [...selectedIPs]);
      } else {
        this.$store.commit('helpStore/setSelectedIPs', [
          ...this.selectedIPs,
          ...ips
        ]);
      }
    },
    toggleSelectAll() {
      // there is a delay, like the one in toogle prefix
      if (!this.selectAll) {
        this.$store.commit('helpStore/setSelectedIPs', this.allIPs);
        this.selectedPrefixes = [];
        this.allPrefixes.forEach(i => {
          this.selectedPrefixes.push(i.prefix);
        });
      } else {
        this.selectedPrefixes = [];
        this.$store.commit('helpStore/setSelectedIPs', []);
      }
    }
  },
  components: {
    TableExpansion
  }
};
</script>

<style lang="scss">
.table {
  margin-bottom: 0;

  // &__protocol {
  //   &--desktop {
  //     @media screen and (max-width: 375px) {
  //       display: none;
  //     }
  //   }
  //   &--mobile {
  //     margin-right: 5px;
  //     display: none;
  //     @media screen and (max-width: 375px) {
  //       display: inline-block;
  //     }
  //   }
  // }

  &__header {
    line-height: 1.1;
    font-size: 16px;
    font-weight: 700;
    padding: 14px;
    background-color: #f8f8f9;
    display: flex;

    & > div {
      flex: 1;
      &:first-child {
        min-width: 180px;
        @media screen and (max-width: 375px) {
          min-width: 155px;
        }
      }
      &:nth-child(2) {
        min-width: 100px;
      }
      @media screen and (max-width: 375px) {
        flex: 0;
        &:first-child {
          flex: 1;
        }

        &:nth-child(2) {
          min-width: 65px;
        }

        &:last-child {
          min-width: 35px;
        }
      }
    }

    @media screen and (max-width: 485px) {
      font-size: 14px;
      padding: 14px 7px;
      & > div {
        &:last-child {
          text-align: right;
        }
      }
    }
  }

  &__row {
    display: flex;
    padding: 14px;
    line-height: 1.1;
    font-size: 16px;
    & > div {
      flex: 1;
      &:first-child {
        min-width: 180px;
        @media screen and (max-width: 375px) {
          min-width: 155px;
        }
        display: flex;
      }
      &:nth-child(2) {
        min-width: 100px;
      }

      @media screen and (max-width: 375px) {
        flex: 0;
        &:first-child {
          flex: 1;
        }

        &:nth-child(2),
        &:nth-child(3) {
          min-width: 65px;
        }

        &:last-child {
          min-width: 35px;
          text-align: right;
        }
      }

      span.ml-2 {
        margin-left: 2px !important;
      }
      span.mr-2 {
        margin-right: 2px !important;
      }
    }

    .clickable {
      cursor: pointer;
    }

    @media screen and (max-width: 485px) {
      font-size: 14px;
      padding: 14px 7px;
      & > div {
        &:last-child {
          text-align: right;
        }
      }
    }

    &.show {
      line-height: 1.1;
      font-size: 16px;
      font-weight: 700;
      background-color: #fbfbfb;
      padding-bottom: 0;

      @media screen and (max-width: 485px) {
        font-size: 14px;
        font-weight: 600;
      }

      .table__cell {
        border-bottom: 1px solid #979797;
        padding-bottom: 4px;
      }
    }
  }

  &__msg {
    text-align: center;
    margin: 15px;
  }

  &__expansion {
    background-color: #fbfbfb;

    .pagination {
      color: #1a1a1a;
      display: flex;
      justify-content: space-between;
      padding: 0 14px;
      align-items: center;
      padding-bottom: 8px;

      a {
        height: 36px;
        color: #1a1a1a;
        border-color: #b3b3b3;
      }

      input {
        line-height: 19px;
        font-size: 16px;
        width: 32px;
        height: 36px;
        text-align: center;
        margin-left: 10px;
      }

      button {
        background-color: #666;
        width: 36px;
        height: 36px;
        color: white;
      }
    }
  }
}
</style>
